import _slicedToArray from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { base64encode } from "./base64";
import { PbLong, PbULong } from "./pb-long";
import { ScalarType } from "./reflection-info";
import { assert, assertFloat32, assertInt32, assertUInt32 } from "./assert";
/**
 * Writes proto3 messages in canonical JSON format using reflection
 * information.
 *
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 */

export var ReflectionJsonWriter = /*#__PURE__*/function () {
  function ReflectionJsonWriter(info) {
    _classCallCheck(this, ReflectionJsonWriter);

    var _a;

    this.fields = (_a = info.fields) !== null && _a !== void 0 ? _a : [];
  }
  /**
   * Converts the message to a JSON object, based on the field descriptors.
   */


  _createClass(ReflectionJsonWriter, [{
    key: "write",
    value: function write(message, options) {
      var json = {},
          source = message;

      var _iterator = _createForOfIteratorHelper(this.fields),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;

          // field is not part of a oneof, simply write as is
          if (!field.oneof) {
            var _jsonValue = this.field(field, source[field.localName], options);

            if (_jsonValue !== undefined) json[options.useProtoFieldName ? field.name : field.jsonName] = _jsonValue;
            continue;
          } // field is part of a oneof


          var group = source[field.oneof];
          if (group.oneofKind !== field.localName) continue; // not selected, skip

          var opt = field.kind == 'scalar' || field.kind == 'enum' ? Object.assign(Object.assign({}, options), {
            emitDefaultValues: true
          }) : options;
          var jsonValue = this.field(field, group[field.localName], opt);
          assert(jsonValue !== undefined);
          json[options.useProtoFieldName ? field.name : field.jsonName] = jsonValue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return json;
    }
  }, {
    key: "field",
    value: function field(_field, value, options) {
      var jsonValue = undefined;

      if (_field.kind == 'map') {
        assert(typeof value == "object" && value !== null);
        var jsonObj = {};

        switch (_field.V.kind) {
          case "scalar":
            for (var _i = 0, _Object$entries = Object.entries(value); _i < _Object$entries.length; _i++) {
              var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                  entryKey = _Object$entries$_i[0],
                  entryValue = _Object$entries$_i[1];

              var val = this.scalar(_field.V.T, entryValue, _field.name, false, true);
              assert(val !== undefined);
              jsonObj[entryKey.toString()] = val; // JSON standard allows only (double quoted) string as property key
            }

            break;

          case "message":
            var messageType = _field.V.T();

            for (var _i2 = 0, _Object$entries2 = Object.entries(value); _i2 < _Object$entries2.length; _i2++) {
              var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                  _entryKey = _Object$entries2$_i[0],
                  _entryValue = _Object$entries2$_i[1];

              var _val = this.message(messageType, _entryValue, _field.name, options);

              assert(_val !== undefined);
              jsonObj[_entryKey.toString()] = _val; // JSON standard allows only (double quoted) string as property key
            }

            break;

          case "enum":
            var enumInfo = _field.V.T();

            for (var _i3 = 0, _Object$entries3 = Object.entries(value); _i3 < _Object$entries3.length; _i3++) {
              var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
                  _entryKey2 = _Object$entries3$_i[0],
                  _entryValue2 = _Object$entries3$_i[1];

              assert(_entryValue2 === undefined || typeof _entryValue2 == 'number');

              var _val2 = this.enum(enumInfo, _entryValue2, _field.name, false, true, options.enumAsInteger);

              assert(_val2 !== undefined);
              jsonObj[_entryKey2.toString()] = _val2; // JSON standard allows only (double quoted) string as property key
            }

            break;
        }

        if (options.emitDefaultValues || Object.keys(jsonObj).length > 0) jsonValue = jsonObj;
      } else if (_field.repeat) {
        assert(Array.isArray(value));
        var jsonArr = [];

        switch (_field.kind) {
          case "scalar":
            for (var i = 0; i < value.length; i++) {
              var _val3 = this.scalar(_field.T, value[i], _field.name, _field.opt, true);

              assert(_val3 !== undefined);
              jsonArr.push(_val3);
            }

            break;

          case "enum":
            var _enumInfo = _field.T();

            for (var _i4 = 0; _i4 < value.length; _i4++) {
              assert(value[_i4] === undefined || typeof value[_i4] == 'number');

              var _val4 = this.enum(_enumInfo, value[_i4], _field.name, _field.opt, true, options.enumAsInteger);

              assert(_val4 !== undefined);
              jsonArr.push(_val4);
            }

            break;

          case "message":
            var _messageType = _field.T();

            for (var _i5 = 0; _i5 < value.length; _i5++) {
              var _val5 = this.message(_messageType, value[_i5], _field.name, options);

              assert(_val5 !== undefined);
              jsonArr.push(_val5);
            }

            break;
        } // add converted array to json output


        if (options.emitDefaultValues || jsonArr.length > 0 || options.emitDefaultValues) jsonValue = jsonArr;
      } else {
        switch (_field.kind) {
          case "scalar":
            jsonValue = this.scalar(_field.T, value, _field.name, _field.opt, options.emitDefaultValues);
            break;

          case "enum":
            jsonValue = this.enum(_field.T(), value, _field.name, _field.opt, options.emitDefaultValues, options.enumAsInteger);
            break;

          case "message":
            jsonValue = this.message(_field.T(), value, _field.name, options);
            break;
        }
      }

      return jsonValue;
    }
    /**
     * Returns `null` as the default for google.protobuf.NullValue.
     */

  }, {
    key: "enum",
    value: function _enum(type, value, fieldName, optional, emitDefaultValues, enumAsInteger) {
      if (type[0] == 'google.protobuf.NullValue') return !emitDefaultValues && !optional ? undefined : null;

      if (value === undefined) {
        assert(optional);
        return undefined;
      }

      if (value === 0 && !emitDefaultValues && !optional) // we require 0 to be default value for all enums
        return undefined;
      assert(typeof value == 'number');
      assert(Number.isInteger(value));
      if (enumAsInteger || !type[1].hasOwnProperty(value)) // if we don't now the enum value, just return the number
        return value;
      if (type[2]) // restore the dropped prefix
        return type[2] + type[1][value];
      return type[1][value];
    }
  }, {
    key: "message",
    value: function message(type, value, fieldName, options) {
      if (value === undefined) return options.emitDefaultValues ? null : undefined;
      return type.internalJsonWrite(value, options);
    }
  }, {
    key: "scalar",
    value: function scalar(type, value, fieldName, optional, emitDefaultValues) {
      if (value === undefined) {
        assert(optional);
        return undefined;
      }

      var ed = emitDefaultValues || optional; // noinspection FallThroughInSwitchStatementJS

      switch (type) {
        // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
        case ScalarType.INT32:
        case ScalarType.SFIXED32:
        case ScalarType.SINT32:
          if (value === 0) return ed ? 0 : undefined;
          assertInt32(value);
          return value;

        case ScalarType.FIXED32:
        case ScalarType.UINT32:
          if (value === 0) return ed ? 0 : undefined;
          assertUInt32(value);
          return value;
        // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
        // Either numbers or strings are accepted. Exponent notation is also accepted.

        case ScalarType.FLOAT:
          assertFloat32(value);

        case ScalarType.DOUBLE:
          if (value === 0) return ed ? 0 : undefined;
          assert(typeof value == 'number');
          if (Number.isNaN(value)) return 'NaN';
          if (value === Number.POSITIVE_INFINITY) return 'Infinity';
          if (value === Number.NEGATIVE_INFINITY) return '-Infinity';
          return value;
        // string:

        case ScalarType.STRING:
          if (value === "") return ed ? '' : undefined;
          assert(typeof value == 'string');
          return value;
        // bool:

        case ScalarType.BOOL:
          if (value === false) return ed ? false : undefined;
          assert(typeof value == 'boolean');
          return value;
        // JSON value will be a decimal string. Either numbers or strings are accepted.

        case ScalarType.UINT64:
        case ScalarType.FIXED64:
          assert(typeof value == 'number' || typeof value == 'string' || typeof value == 'bigint');
          var ulong = PbULong.from(value);
          if (ulong.isZero() && !ed) return undefined;
          return ulong.toString();
        // JSON value will be a decimal string. Either numbers or strings are accepted.

        case ScalarType.INT64:
        case ScalarType.SFIXED64:
        case ScalarType.SINT64:
          assert(typeof value == 'number' || typeof value == 'string' || typeof value == 'bigint');
          var long = PbLong.from(value);
          if (long.isZero() && !ed) return undefined;
          return long.toString();
        // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
        // Either standard or URL-safe base64 encoding with/without paddings are accepted.

        case ScalarType.BYTES:
          assert(value instanceof Uint8Array);
          if (!value.byteLength) return ed ? "" : undefined;
          return base64encode(value);
      }
    }
  }]);

  return ReflectionJsonWriter;
}();